import { render, staticRenderFns } from "./infoForm.vue?vue&type=template&id=080d3dda&"
import script from "./infoForm.vue?vue&type=script&lang=js&"
export * from "./infoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports